import * as React from 'react';
import { Widget, getWidgetProps, WPSClient, PaymentMessage, RequestContext } from 'DVWebNodeUtils';
import transform from './transforms';
import { MessageBlock, MessageTypes } from '@amzn/dvui/dist/Block';
import { Text } from '@amzn/dvui/dist/Text';

export interface MFABlockProps  {
    message: PaymentMessage,
    isDismissable: boolean,
    context: RequestContext,
    csrfToken: string
}

const getProps: getWidgetProps<MFABlockProps> = global.__SERVER__
	? async ({ context, redirectDomainName }, api) => {
		  const wpsClient = new WPSClient(api)
		  const response = await wpsClient.GetPaymentStateMessages({ context: context, redirectDomainName: redirectDomainName })
        return transform(context, response)
	}
   : undefined;

const dismissHandler = async (context: RequestContext, dialogID: string, csrfToken: string) => {
    try {
        const wpsClient = new WPSClient();
        await wpsClient.RecordDialogDismissal({
            context: context,
            dialogID: dialogID,
            dialogType: "MFARiskMsg",
            csrfToken: csrfToken
        });
    } catch(e) {
        //TODO add error logging with withArgs
    }
};

const paymentStateMsgComponent = (props: MFABlockProps) => (
    props.message.title ? <MessageBlock type={props.message.msgType === 'ERROR' ? MessageTypes.error : MessageTypes.warning} heading={props.message.title} 
        dismissable={props.isDismissable} onDismiss={() => { dismissHandler(props.context, props.message.id, props.csrfToken); }}><Text string={props.message.main} /></MessageBlock>
	: null
);

export const PaymentStateMsg: Widget<MFABlockProps> = {
    name: 'payment-state-msg',
    getProps,
    Component: paymentStateMsgComponent,
    container: {
      tagName: 'div',
    }
}
